export default __webpack_public_path__ + "static/media/emailmark.f40bc7f421de9951ec2071f695f0603b.svg";